import {stringify} from 'query-string'
import moment from "moment"

export const API_ROOT = process.env.NODE_ENV === 'production' ? '/rest-service/' : 'http://localhost:8080/fakturito-dev/rest-service/';

export const serialize = (json) => {
	if (json) {
		for (let k in json) {
			if (json.hasOwnProperty(k) && json[k]) {
				if (json[k] instanceof Date) {
					json[k].toJSON = () => {
						return moment(json[k]).format("YYYY-MM-DD")
					}
				} else if (json[k] instanceof moment) {
					json[k].toJSON = () => {
						return json[k].format("YYYY-MM-DD")
					}
				}
			}
		}
	}
	return JSON.stringify(json)
};

export const flatten = (filter) => {
	let query = {};
	if (filter) {
		for (let k in filter) {
			if (filter.hasOwnProperty(k) && (filter[k] || filter[k] === 0 || filter[k] === false)) {
				let value = filter[k];
				if (value && value.constructor === Array) {
					for (let j in value) {
						if (value.hasOwnProperty(j)) {
							if (value[j].value) {
								// flatten as sent from multi-select
								value[j] = value[j].value
							}
						}
					}
				} else if (value instanceof moment) {
					value = value.format("YYYY-MM-DD");
				}
				query[k] = value
			}
		}
	}
	return query
};

const resolveError = (result, failureType) => {

	if (result && result.result === 'WARNING') {
		return result.message || 'Varování'
	}

	if (!result.message) {
		// general failure
		return "Komunikaci se serverem selhala (" + result.message + ", " + failureType + ")"
	}
	const values = {};
	if (result.messageValues) {
		for (let k in result.messageValues) {
			if (!result.messageValues.hasOwnProperty(k)) {
				continue;
			}
			values[k] = result.messageValues[k];
		}
	}

	switch (result.message) {
		case "INVALID_PARAMETER":
		case "VALIDATION_ERROR":
		case "GENERAL_ERROR":
		default:
			return failureType + ": " + JSON.stringify(result);
	}
};

const callApi = (endpoint, filter, body, method) => {
	let query = flatten(filter);

	const fullUrl = ((endpoint.indexOf(API_ROOT) === -1) ? API_ROOT + endpoint : endpoint)
		+ (Object.keys(query).length > 0 ? '?' + stringify(query) : '');

	const options = {
		method: method || (body ? 'POST' : 'GET'),
		body: body ? (body instanceof FormData ? body : serialize(body)) : undefined,
		headers: {},
		credentials: 'include'
	};
	options['headers']['Pragma'] = 'no-cache';

	if (body) {
		options['headers']['Accept'] = 'application/json';
		if (body instanceof FormData) {
			// header already set (with boundary)
		} else {
			options['headers']['Content-type'] = 'application/json';
		}
	}

	return fetch(fullUrl, options).then(response => {
		return response.json().catch(error => {
			if (response.status >= 500) {
				return Promise.reject({"message": "Interní chyba - " + response.statusText})
			}
			return Promise.reject({"message": "Neplatná odpověď: " + error.message})
		})

	}).then(json => {
		if ((json.result !== 'OK')) {
			return Promise.reject(json)
		}
		return json

	}).catch(error => {
		return Promise.reject(error)
	})
};

export const BACKEND_API = 'BE API';

// export const callApiWithCallback = (endpoint, schema, callback) => {
// 	return callApi(endpoint, schema).then(
// 		response => callback(response, null),
// 		error => callback(null, error)
// 	)
// }

export default store => next => action => {
	const callAPI = action[BACKEND_API];
	if (typeof callAPI === 'undefined') {
		return next(action)
	}

	let {endpoint} = callAPI;
	const {types, filter, body = null, silent = false, method = null} = callAPI;

	if (typeof endpoint === 'function') {
		endpoint = endpoint(store.getState())
	}

	if (typeof endpoint !== 'string') {
		throw new Error('Specify a string endpoint URL.')
	}
	if (!Array.isArray(types) || types.length !== 3) {
		throw new Error('Expected an array of three action types.')
	}
	if (!types.every(type => typeof type === 'string')) {
		throw new Error('Expected action types to be strings.')
	}

	const actionWith = data => {
		const finalAction = Object.assign({}, action, data);
		delete finalAction[BACKEND_API];
		return finalAction
	};

	const [requestType, successType, failureType] = types;
	next(actionWith({type: requestType}));

	return callApi(endpoint, filter, body, method).then(
		response => next(actionWith({
			response,
			type: successType,
			success: (response.messageValues && response.messageValues.message ? response.messageValues && response.messageValues.message : response.message),
			filter
		})),
		error => next(actionWith({
			type: failureType,
			error: resolveError(error, failureType),
			data: error && error.data ? error.data : null,
			result: error && error.result ? error.result : "ERROR",
			silent,
			filter
		}))
	)
}
